import { faIdBadge } from '@fortawesome/pro-light-svg-icons/faIdBadge';
import { faMapMarkerAlt } from '@fortawesome/pro-light-svg-icons/faMapMarkerAlt';
import { AgentResult } from '@propertypal/shared/src/types/agents';
import Link from 'next/link';
import React, { FunctionComponent } from 'react';
import { useTheme } from 'styled-components';
import Button from '../buttons/Button';
import Chevron from '../icons/Chevron';
import FontAwesomeIcon from '../icons/FontAwesomeIcon';
import { SmallHeading, Text, LinkText } from '../typography';
import { Accreditations, AgentLogo, ButtonBox, Container, Content, InfoRow, PropertiesTag } from './AgentBox.style';
import ContactAgent from './ContactAgent';

interface Props {
  agent: AgentResult;
  onEmailClick: (agent: AgentResult) => void;
  showTotalProperties?: boolean;
}

const AgentBox: FunctionComponent<Props> = (props) => {
  const { agent } = props;
  const theme = useTheme();
  // const accreditations = [...(agent.account.accreditations || []), ...(agent.account.propertypalAwards || [])];
  const accreditations = agent.account.accreditations || [];

  return (
    <Container data-testid={`agent-box-${agent.accountNumber}`}>
      {props.showTotalProperties && <PropertiesTag>{agent.totalUnits}</PropertiesTag>}

      <AgentLogo src={agent.account.logo?.standard} alt={agent.account.organisation} />

      <Content>
        <div>
          <SmallHeading color={theme.textDark} fontSize={20} mt={10}>
            {agent.account.organisation} {agent.account.organisationBranch && `(${agent.account.organisationBranch})`}
          </SmallHeading>

          <InfoRow>
            <FontAwesomeIcon icon={faMapMarkerAlt} color={theme.textDark} style={{ fontSize: 24 }} />
            <Text>{agent.account.displayAddress}</Text>
          </InfoRow>

          <InfoRow>
            <FontAwesomeIcon icon={faIdBadge} color={theme.textDark} style={{ fontSize: 24 }} />
            <Link href={agent.url} prefetch={false}>
              <LinkText as="span">
                View Agent Profile <Chevron color={theme.primary} size={12} />
              </LinkText>
            </Link>
          </InfoRow>

          {!!accreditations.length && (
            <Accreditations>
              {accreditations.map((accreditation) => (
                <a
                  key={accreditation.url}
                  href={accreditation.url}
                  aria-label={accreditation.label}
                  target="_blank"
                  rel="noreferrer"
                >
                  <img src={accreditation.imageUrl} alt={accreditation.label} />
                </a>
              ))}
            </Accreditations>
          )}
        </div>

        <ButtonBox>
          {agent.account.officePhone && agent.account.officePhone.displayNumber && (
            <ContactAgent agent={agent.account} page="Find an Agent" location="Search Result" />
          )}

          <Button
            containerStyle={{ minWidth: 220, marginTop: 15 }}
            onClick={() => props.onEmailClick(props.agent)}
            testID={`emailAgent${agent.accountNumber}`}
          >
            Email the Agent
          </Button>
        </ButtonBox>
      </Content>
    </Container>
  );
};

export default AgentBox;
